var exports = {
  "Nr": "x8b4e8595--0b1f08--card",
  "jW": "x8b4e8595--0b1f08--photo",
  "Sl": "x8b4e8595--0b1f08--image",
  "U3": "x8b4e8595--0b1f08--builder-logo",
  "Wc": "x8b4e8595--0b1f08--builder-logo-image",
  "Qs": "x8b4e8595--0b1f08--content",
  "cL": "x8b4e8595--0b1f08--builder",
  "DD": "x8b4e8595--0b1f08--title",
  "q9": "x8b4e8595--0b1f08--price",
  "h5": "x8b4e8595--0b1f08--status",
};

module.exports = exports;
